import { escapeHtml, sanitizeUrl } from './sanitize-html';

function processNode(node) {
  if (!node) return '';

  let html = '';

  switch (node.type) {
    case 'text':
      {
        // Escape the raw text value — this output is fed to
        // dangerouslySetInnerHTML, so an unescaped `<` / `"` in a metafield
        // value would inject markup. bold/italic wrappers are applied AFTER
        // escaping so the structural tags survive.
        let text = escapeHtml(node.value || '');
        if (node.bold) text = `<strong>${text}</strong>`;
        if (node.italic) text = `<em>${text}</em>`;
        html += text;
      }
      break;
    case 'paragraph':
      html += `<p>`;
      if (node.children) {
        node.children.forEach((child) => {
          html += processNode(child);
        });
      }
      html += `</p>`;
      break;
    case 'list':
      html += `<ul>`;
      if (node.children) {
        node.children.forEach((child) => {
          html += processNode(child);
        });
      }
      html += `</ul>`;
      break;
    case 'list_item':
      html += `<li>`;
      if (node.children) {
        node.children.forEach((child) => {
          html += processNode(child);
        });
      }
      html += `</li>`;
      break;
    case 'heading':
      {
        // Clamp to 1-6 so the level (which is interpolated raw into the tag
        // name) can never inject attributes/markup from malformed metafield
        // JSON — the tag can only ever be h1-h6.
        const headingLevel = Math.min(6, Math.max(1, parseInt(node.level, 10) || 1));
        html += `<h${headingLevel}>`;
        if (node.children) {
          node.children.forEach((child) => {
            html += processNode(child);
          });
        }
        html += `</h${headingLevel}>`;
      }
      break;
    case 'image':
      {
        const src = sanitizeUrl(node.src);
        if (src) {
          html += `<img src="${escapeHtml(src)}" alt="${escapeHtml(node.alt || '')}">`;
        }
      }
      break;
    case 'link':
      {
        const href = sanitizeUrl(node.url);
        // Render the anchor only for safe schemes (drops javascript:/data:);
        // otherwise still render the link text so copy isn't lost.
        if (href) html += `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer">`;
        if (node.children) {
          node.children.forEach((child) => {
            html += processNode(child);
          });
        }
        if (href) html += `</a>`;
      }
      break;
    default:
    // console.warn('Unknown node type:', node.type);
  }

  return html;
}

const richTextToHTML = (data) => {
  const parsedJson = typeof data === 'string' ? JSON.parse(data) : data;

  if (!parsedJson || !parsedJson.children) return '';

  let html = '';

  parsedJson.children.forEach((child) => {
    html += processNode(child);
  });

  return html;
};

export default richTextToHTML;
